import { api } from '../api/index';
import ActionTypes from '../constants/ActionTypes';
import { isJobLoaded } from '../selectors/job';
import { fetchCategory } from './category';
import { fetchLocation } from './location';
import qs from 'query-string';
import { omit } from 'lodash';
import { replace, push } from 'react-router-redux';
import Socium from '../constants/Socium';
import Cookies from 'universal-cookie';

import redirectToHome from '../utils/redirectToHome';

// Backoff schedule for the 404 retry below. Two retries (~2s total wait)
// absorb the read-after-write race where JP has created the job
// synchronously but the JobPostedEvent consumer hasn't backfilled the
// legacy `jobs` row yet, so socium's getJobById INNER JOIN on `start_by`
// filters the stub row out and returns 404. See TUP-167.
const FETCH_JOB_404_BACKOFFS_MS = [500, 1500];

export const fetchJobWithRetryOn404 = async () => {
  for (let attempt = 0; attempt <= FETCH_JOB_404_BACKOFFS_MS.length; attempt += 1) {
    try {
      return await api.get(`jobs`, getTokenHeader());
    } catch (error) {
      const status = error && error.response && error.response.status;
      const isLastAttempt = attempt === FETCH_JOB_404_BACKOFFS_MS.length;
      if (status !== 404 || isLastAttempt) throw error;
      await new Promise(resolve => setTimeout(resolve, FETCH_JOB_404_BACKOFFS_MS[attempt]));
    }
  }
};

export const fetchJob = id => {
  return async (dispatch, getState) => {
    if (isJobLoaded(getState(), id)) return;
    try {
      const { data: job } = await fetchJobWithRetryOn404();
      await dispatch(fetchCategory(job.categoryId));
      await dispatch(fetchLocation(job.suburbId));
      return dispatch({
        type: ActionTypes.FETCH_JOB_SUCCESS,
        payload: job
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.FETCH_JOB_NOT_FOUND,
        payload: { id },
        error
      });
      return dispatch(push('/install'));
    }
  };
};

export const closeJobAction = jobId => {
  return async dispatch => {
    // const { data: job } = await api.get(`jobs/${id}`);
    return dispatch({
      type: ActionTypes.CLOSE_JOB_SUCCESS,
      payload: jobId
    });
  };
};

export const fetchJobInvitations = id => {
  return async dispatch => {
    try {
      const { data: invitations } = await api.get(`jobs/invitations`, getTokenHeader());
      return dispatch({
        type: ActionTypes.FETCH_JOB_INVITATIONS_SUCCESS,
        payload: invitations
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.FETCH_JOB_INVITATIONS_ERROR,
        payload: { id },
        error
      });
    }
  };
};

export const fetchJobStatus = id => {
  return async dispatch => {
    try {
      const { data: status } = await api.get(`jobs/status`, getTokenHeader()).catch(redirectToHome);
      return dispatch({
        type: ActionTypes.FETCH_JOB_STATUS_SUCCESS,
        payload: status
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.FETCH_JOB_STATUS_ERROR,
        payload: { id },
        error
      });
    }
  };
};

export function markCheckpoint(id, checkpoint, time) {
  return {
    type: ActionTypes.MARK_CHECKPOINT,
    payload: { id: `${id}-${checkpoint}`, marked: true, time: time || +new Date() }
  };
}
``;

export function clearCheckpoint(id, checkpoint) {
  return {
    type: ActionTypes.UNMARK_CHECKPOINT,
    payload: { id: `${id}-${checkpoint}` }
  };
}

export function checkIfFirstView(id) {
  return (dispatch, getState) => {
    const state = getState();
    const { location } = state.routing;
    if (!location) return;
    const query = qs.parse(location.search);
    if (query.fty) {
      dispatch({ type: ActionTypes.SET_IS_FIRST_VIEW, payload: { id } });
      dispatch(
        replace({
          pathname: location.pathname,
          search: qs.stringify(omit(query, 'fty'))
        })
      );
    }
  };
}

export const fetchJobConnections = id => {
  return async dispatch => {
    try {
      const { data: connections } = await api.get(`jobs/connections`, getTokenHeader());
      return dispatch({
        type: ActionTypes.FETCH_JOB_CONNECTIONS_SUCCESS,
        payload: connections
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.FETCH_JOB_CONNECTIONS_ERROR,
        payload: { id },
        error
      });
    }
  };
};

const getTokenFromCookie = () => {
  const cookies = new Cookies();
  return cookies.get(Socium.COOKIE_TOKEN) || '';
};

const getTokenHeader = () => {
  const token = getTokenFromCookie();
  return {
    params: { t: +new Date() },
    headers: { Authorization: token }
  };
};
